import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layout from "./Components/Layout/Layout.jsx";
import Home from "./Components/Home/Home.jsx";
import Rooms from "./Components/Rooms/Rooms.jsx";
import About from "./Components/About/About.jsx";
import Contact from "./Components/Contact/Contact.jsx";
import Gallery from "./Components/Gallery/Gallery.jsx";
import "./App.scss";

const App = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route exact="true" path="/" element={<Home />} />
          <Route exact="true" path="/rooms" element={<Rooms />} />
          <Route exact="true" path="/about" element={<About />} />
          <Route exact="true" path="/contact" element={<Contact />} />
          <Route exact="true" path="/gallery" element={<Gallery />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
